import '@testing-library/jest-dom';
import { render, screen, fireEvent } from '@testing-library/react';

import { RadioGroup } from './RadioGroup';

const options = [
  { id: '1', titleLabel: 'Option 1', value: 'option1' },
  { id: '2', titleLabel: 'Option 2', value: 'option2' },
];

describe('RadioGroup', () => {
  it('should render correctly', () => {
    render(<RadioGroup label="Test Label" options={options} onChange={jest.fn()} />);
    expect(screen.getByText('Test Label')).toBeInTheDocument();
    expect(screen.getByText('Option 1')).toBeInTheDocument();
    expect(screen.getByText('Option 2')).toBeInTheDocument();
  });

  it('should call onChange when an option is selected', () => {
    const handleChange = jest.fn();
    render(<RadioGroup label="Test Label" options={options} onChange={handleChange} />);

    const option1 = screen.getByLabelText('Option 1');
    fireEvent.click(option1);
    expect(handleChange).toHaveBeenCalledWith('option1');
  });

  it('should not allow selection when disabled', () => {
    const handleChange = jest.fn();
    render(<RadioGroup label="Test Label" options={options} onChange={handleChange} disabled />);

    const option1 = screen.getByLabelText('Option 1');
    fireEvent.click(option1);
    expect(handleChange).not.toHaveBeenCalled();
  });
});
